export function getTripMapPadding(isMobile, halfDrawerHeightRef, mobileDrawerHeight, mobileDrawerState, isDesktopViewExpanded) {
  let padding = {
    top: 80, 
    bottom: 80, 
    left: isDesktopViewExpanded ? 350 : 0, 
    right: 0  
  }

  if (isMobile) {
    padding = getMobilePadding(halfDrawerHeightRef, mobileDrawerHeight, mobileDrawerState)
  }

  return padding;
}

function getMobilePadding(halfDrawerHeightRef, mobileDrawerHeight, mobileDrawerState) {
  // Step 1: Capture half height only once (at initial render or first 'half' open)
  if (mobileDrawerState === 'half' && halfDrawerHeightRef.current === null) {
    halfDrawerHeightRef.current = mobileDrawerHeight;
  }

  // Step 2: Choose the smallest valid padding (capped at half height)
  const maxPadding =
    halfDrawerHeightRef.current !== null
      ? Math.min(mobileDrawerHeight, halfDrawerHeightRef.current)
      : mobileDrawerHeight;

  // Step 3: Always apply the padded value (even when going back to 'half')
  return {
    top: 0,
    bottom: maxPadding,
    left: 0,
    right: 0,
  };
}
